module.exports = __webpack_public_path__ + "static/media/G.36ad3246.png";